import React from 'react';
import './Skills.css';

const Skills = () => {
  const skillCategories = [
    {
      title: "Programming",
      skills: ["Python", "Java", "JavaScript", "React.js", "C", "R", "VBA"]
    },
    {
      title: "ML & Data",
      skills: ["PyTorch", "Transformers", "LoRA", "Reinforcement Learning", "MCTS", "Model Evaluation", "Linear Regression"]
    },
    {
      title: "Risk / GRC",
      skills: ["Governance", "Risk Management", "Compliance", "Data Protection", "Cyber Risk Quantification", "OpenFAIR"]
    },
    {
      title: "Tools & Software",
      skills: ["Excel", "Access", "Dynamics AX", "SAP", "Supabase", "AutoCAD", "Creo/ProE"]
    }
  ];

  return (
    <section id="skills" className="skills-section">
      <h2 className="section-title">Technical Skills</h2>
      
      <div className="skills-grid">
        {skillCategories.map((category, idx) => (
          <div key={idx} className="skill-card glass-panel">
            <div className="skill-card-icon">
              {/* Decorative circle representing category */}
            </div>
            <h3>{category.title}</h3>
            <ul className="skill-list">
              {category.skills.map((skill, i) => (
                <li key={i} className="skill-item">
                  <span className="bullet"></span> {skill}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Skills;
